export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-axis/src/identity.js
// module id = 228
// module chunks = 0 1 2 3 4